export default {
  default: {
    container: "",
    card: "bg-paper border-2 border-primary rounded-2xl p-5 flex flex-col sm:flex-row items-center gap-4",
    icon_wrapper: "w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0",
    icon: "w-5 h-5 text-primary",
    info: "flex-1 min-w-0",
    title: "font-semibold text-text text-center sm:text-left truncate",
    description: "text-sm text-text_secondary text-center sm:text-left truncate",
    meta: "text-sm text-text_secondary text-center sm:text-left mt-0.5",
    meta_version: "font-semibold text-text",
    action: "shrink-0 sm:ml-auto",
    button_variant: "primary",
    action_link: "inline-flex items-center gap-2 text-sm text-primary font-medium hover:underline",
    changelog_container: "bg-paper/80 border border-bordered rounded-2xl p-5 mt-4",
    changelog_heading: "text-xs font-semibold uppercase tracking-wider text-text_secondary mb-4",
    changelog_entries: "space-y-5",
    changelog_version: "font-bold text-text uppercase tracking-wide text-sm",
    changelog_date: "text-xs text-text_secondary",
    changelog_text: "text-sm text-text_secondary mt-1.5 space-y-1 list-none pl-0",
    changelog_line: "flex items-start gap-2",
    changelog_bullet: "shrink-0 select-none",
  },
}
